import React from 'react';

const NoMockAllocationIcon = () => {
  return (
    <svg
      width="160"
      height="100"
      viewBox="0 0 160 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M155.555 87.9277C151.193 83.3963 145.066 80.5775 138.279 80.5775C135.588 80.5775 133.002 81.02 130.587 81.8367C127.971 78.0154 123.576 75.5053 118.596 75.5053C116.827 75.5053 115.13 75.8221 113.562 76.4012C108.531 66.2049 98.0318 59.1934 85.8962 59.1934C70.1933 59.1934 57.2329 70.9275 55.3072 86.1058C53.1248 85.5404 50.8386 85.2427 48.4787 85.2427C41.3552 85.2427 34.8736 87.9796 30.0254 92.4618"
        stroke="black"
        strokeWidth="0.540817"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M88.6707 1.00049V85.7858C86.5129 86.1327 84.4534 86.7691 82.5332 87.6514V1.00049H88.6707Z"
        fill="white"
        stroke="black"
        strokeWidth="0.480726"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M38.9012 19.6762L7.98429 33.7443L33.5552 51.8246L142.608 59.5652L144.905 27.2003L38.9012 19.6762Z"
        fill="#545454"
        stroke="black"
        strokeWidth="0.540817"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M36.3434 15.598L5.42354 29.6687L34.0461 47.9629L140.047 55.4868L142.344 23.1219L36.3434 15.598Z"
        fill="white"
        stroke="black"
        strokeWidth="0.540817"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M37.8673 18.5568L12.5897 30.1774L35.9725 45.2519L137.178 52.4354L139.073 25.7403L37.8673 18.5568Z"
        fill="#E6F1FF"
        stroke="black"
        strokeWidth="0.540817"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M140.047 55.4869L142.345 23.1221L144.906 27.2004L142.609 59.5653L140.047 55.4869Z"
        fill="#DBDBDB"
        stroke="black"
        strokeWidth="0.540817"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M33.556 51.8249L34.0464 47.9632L5.42383 29.6689L7.98508 33.7446L33.556 51.8249Z"
        fill="#DBDBDB"
        stroke="black"
        strokeWidth="0.540817"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M113.628 98.5007C109.711 90.779 101.697 85.4883 92.4484 85.4883C91.1619 85.4883 89.9 85.5893 88.6708 85.786C86.513 86.1329 84.4536 86.7693 82.5334 87.6515C78.0976 89.6946 74.3993 93.0624 71.9492 97.2524"
        stroke="black"
        strokeWidth="0.540817"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.8223 2.56665L40.0372 3.34016"
        stroke="black"
        strokeWidth="0.540817"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M135.381 67.1802L154.93 68.302"
        stroke="black"
        strokeWidth="0.540817"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default NoMockAllocationIcon;
